import Component from 'gia/Component'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import _each from 'lodash.foreach'

gsap.registerPlugin(ScrollTrigger);

class Makers extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.element = element

      this.ref = {
        text: null,
        images: null,
        video: null,
        bg: null
      }

      this.options = {
        start: "top top",
        color: "#4d4d4d",
        start: "bottom bottom"
      }

  }

  mount() {


    // ScrollTrigger.create({
    //     id: "triger21",
    //     trigger: this.element,
    //     start: this.options.start,
    //     onEnter: self => gsap.to(".bg__bg--grey", {
    //       opacity:1,
    //       //ease: "power4.inOut",
    //       duration: .71,
    //       ease: 'expo.out'
    //     }),
    //     onLeaveBack: self => gsap.to(".bg__bg--grey", {
    //       opacity: 0,
    //       //ease: "power4.inOut",
    //       duration: .71,
    //       ease: 'expo.out'
    //     })
    //
    //   });





    this.animation = gsap.fromTo(this.ref.text,
      {
        yPercent: 0,
        ease: "power2.in",
        force3D: true
      },
      {
      yPercent: -100,
      ease: "power2.in",
      force3D: true,
      scrollTrigger: {
        id: "trigger22",
        trigger: this.element,
        start: "top top", // the default values
        end: "bottom top-=50%",
        scrub: .1
      },
    });

    ScrollTrigger.create({
        id: "triger26",
        trigger: '.story',
        start: "top top-=75%", // the default values
        onEnter: (self) => {
          //$(this.ref.text).addClass('hide')
          $('html').addClass('blue')
        },
        onLeaveBack: (self) => {
          //$(this.ref.text).removeClass('hide')
          $('html').removeClass('blue')
        }
      });



    this.animation1 = gsap.fromTo('.makers-story',
      {
        yPercent: 0,
        ease: "none",
        force3D: true
      },
      {
      yPercent: -40,
      force3D: true,
      ease: "none",
      scrollTrigger: {
        id: "trigger23",
        trigger: '.story',
        start: "top top-=175%", // the default values
        end: "bottom top+=50%",
        scrub: true
      },
    });

    // this.animation2 = gsap.fromTo(this.ref.bg,
    //   {
    //     yPercent: 100,
    //     ease: "none",
    //     force3D: true
    //   },
    //   {
    //   yPercent: -100,
    //   force3D: true,
    //   ease: "none",
    //   scrollTrigger: {
    //     trigger: this.ref.images,
    //     scrub: .5
    //   }
    //
    // });


    $('.push-left').on('click', (e)=>{
      e.preventDefault()
      this.body.addClass('has-push')
      $('.c-left').addClass('is-opened')
    })

    $('.push-right').on('click', (e)=>{
      e.preventDefault()
      this.body.addClass('has-push')
      $('.c-right').addClass('is-opened')
    })

    $('.push__bg').on('click', (e)=>{
      e.preventDefault()
      this.body.removeClass('has-push')
      $('.push').removeClass('is-opened')
    })

    $('.back').on('click', (e)=>{
      e.preventDefault()
      this.body.removeClass('has-push')
      $('.push').removeClass('is-opened')
    })




  }


  unmount() {

    ScrollTrigger.getById("trigger26").kill();
    // ScrollTrigger.getById("trigger21").kill();
    this.animation.ScrollTrigger.kill();
    this.animation1.ScrollTrigger.kill();
  }


}

module.exports = Makers
